import { type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface Step {
  key: string;
  label: string;
  hint: string;
  icon: LucideIcon;
  count?: number;
}

export function PipelineStepper({ steps, active, onSelect }: { steps: Step[]; active: string; onSelect: (key: string) => void }) {
  const activeIndex = steps.findIndex((s) => s.key === active);

  return (
    <div className="flex items-stretch gap-2">
      {steps.map((step, i) => {
        const isActive = step.key === active;
        const isDone = i < activeIndex;
        const Icon = step.icon;
        return (
          <div key={step.key} className="flex flex-1 items-center gap-2">
            <button
              onClick={() => onSelect(step.key)}
              className={cn(
                'flex flex-1 items-start gap-3 rounded-lg border p-3 text-left transition-colors',
                isActive ? 'border-violet-500/50 bg-violet-50 dark:bg-violet-950/40' : 'bg-card hover:border-muted-foreground/40',
              )}
            >
              <span
                className={cn(
                  'flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold',
                  isActive
                    ? 'bg-violet-600 text-white'
                    : isDone
                      ? 'bg-emerald-500/15 text-emerald-600'
                      : 'bg-muted text-muted-foreground',
                )}
              >
                {i + 1}
              </span>
              <span className="min-w-0">
                <span className="flex items-center gap-1.5 text-sm font-medium">
                  <Icon className="h-4 w-4" />
                  {step.label}
                  {typeof step.count === 'number' && <span className="text-muted-foreground">({step.count})</span>}
                </span>
                <span className="mt-0.5 block text-xs text-muted-foreground">{step.hint}</span>
              </span>
            </button>
            {i < steps.length - 1 && <span className="hidden text-muted-foreground/40 sm:block">→</span>}
          </div>
        );
      })}
    </div>
  );
}
